import script from "./AllergensView.vue?vue&type=script&setup=true&lang=js"
export * from "./AllergensView.vue?vue&type=script&setup=true&lang=js"

import "./AllergensView.vue?vue&type=style&index=0&id=e0b88058&lang=scss"

const __exports__ = script;

export default __exports__